import { IProcessSolucionareViewModel } from 'viewModels';
import api from '../services/api/axios';

const getProcessSolucionare = (numberProcess: string) =>
  new Promise<IProcessSolucionareViewModel>((resolve, reject) => {
    api
      .get(`solucionare/${numberProcess}`)
      .then(({ data }) => resolve(data))
      .catch(() => reject());
  });

const SolucionareController = { getProcessSolucionare };

export default SolucionareController;
